import React from "react";
import useReady from "../hook/useReady";
import {WechatSDK} from "../lib/sdk";


export interface WechatMenuConfigProps {
    disabledShare?: boolean;
    children: React.ReactElement;
}
function WechatMenuConfig(props: WechatMenuConfigProps): React.ReactElement {
    const {
        disabledShare = false,
        children
    } = props;
    useReady(() => {
        const items: any[] = [
            "menuItem:share:appMessage",
            "menuItem:share:timeline",
            "menuItem:share:qq",
            "menuItem:share:weiboApp",
            "menuItem:share:facebook",
            "menuItem:share:QZone"
        ]
        if (disabledShare) {
            // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
            WechatSDK.hideMenuItems(items);
        } else {
            WechatSDK.showMenuItems(items)
        }

    }, [disabledShare])
    return children;
}

export default WechatMenuConfig;